module.exports = __webpack_public_path__ + "img/text.41278eb3.png";